import { patientRequestsTyped } from "@/api/(requests)/patientTyped";
import type { ProfileUpdatePayload } from "@/core/types";

export async function updateMemberProfile(body: ProfileUpdatePayload) {
  return patientRequestsTyped.update_profile({ body, context: { showLoader: false } });
}
